import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCurrentUserProfile } from '../services/api';
import { getCurrentUser } from '../services/auth';

function Profile() {
  const claims = getCurrentUser() || {};
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getCurrentUserProfile()
      .then(setProfile)
      .catch(() => setProfile(null)) // fall back to token claims
      .finally(() => setLoading(false));
  }, []);

  const email = profile?.email || claims.email || '—';
  const username =
    profile?.username || claims.name || claims['cognito:username'] || '—';
  const memberSince = profile?.created_at
    ? new Date(profile.created_at * 1000).toLocaleDateString()
    : null;

  return (
    <div className="row justify-content-center">
      <div className="col-md-7">
        <h1 className="mb-4">Profile</h1>
        <div className="card">
          <div className="card-body">
            {loading ? (
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <dl className="row mb-0">
                <dt className="col-sm-4">Email</dt>
                <dd className="col-sm-8">{email}</dd>

                <dt className="col-sm-4">Display name</dt>
                <dd className="col-sm-8">{username}</dd>

                {memberSince && (
                  <>
                    <dt className="col-sm-4">Member since</dt>
                    <dd className="col-sm-8">{memberSince}</dd>
                  </>
                )}
              </dl>
            )}
          </div>
        </div>

        <div className="mt-3 d-flex gap-2">
          <Link to="/my-listings" className="btn btn-outline-primary">
            My Listings
          </Link>
        </div>

        <p className="text-muted small mt-4">
          More profile settings (display name, contact info, avatar) coming soon.
        </p>
      </div>
    </div>
  );
}

export default Profile;
